module.exports = __webpack_public_path__ + "assets/img/download3.52b97b92.jpg";